
import React from 'react';

function Fashion() {
  return (
    <div>
      <h1>Fashion Page</h1>
    </div>
  );
}

export default Fashion;
